// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3Lg8c","errorLogs":"styles_errorLogs__3k-WG"};